import { render } from "./collaborator-profile-table-cyc.vue?vue&type=template&id=647700ae"
import script from "./collaborator-profile-table-cyc.vue?vue&type=script&lang=js"
export * from "./collaborator-profile-table-cyc.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__